angular
        .module('topTitleInfo.components', [])
        .component('topTitleInfo', {
            templateUrl: 'ng/components/topTitleInfo/topTitleInfo.html',
            bindings: {
                name: '@',
                icon: '@',
                count: '='
                
                
            },
            controllerAs: 'topTitleInfoCtrl',
            controller: function ($scope, $translate) {
                this.$onInit = function () {  
                }
            }
        });
